/* eslint-disable react/prop-types */

'use strict';

const { h, Component } = require('phy');

const DiscountBadge = require('./discount_badge');
const PriceLabel = require('./label');
const MSRPLabel = require('./msrp_label');
const Value = require('./value');
const Price = require('./price');
const DoublestrikeRegularPrice = require('./doublestrike_regular_price');
const UrgencyPricingLabel = require('./urgency_price_label');
const GoodsShippingLabel = require('../../../../goods_shipping/components/shipping_label');
const VariablePricing = require('../variable_pricing');
const getOptionPromoIneligible = require('../promo_ineligible');

class OptionPricing extends Component {
  shouldShowPriceInSecondRow() {
    /*
      we should only push the price the second row if its:
        - a touch inline variations deal
        - desktop variations deal, with an option selected
          that has msrp label or urgency pricing
    */
    const {
      isGliveTouchSection,
      isTraitsSummary,
      option: {
        pricing: { msrpLabel },
        showDoubleStrikeThroughPrice,
      },
      touchRequest,
    } = this.props;
    return (
      (touchRequest && (isTraitsSummary || isGliveTouchSection)) ||
      (!touchRequest &&
        isTraitsSummary &&
        (msrpLabel || showDoubleStrikeThroughPrice))
    );
  }

  shouldShowPriceInFirstRow() {
    return !this.shouldShowPriceInSecondRow();
  }

  getVariablePricing() {
    const {
      option: { variablePricing },
    } = this.props;

    if (!variablePricing) {
      return null;
    }

    return h(
      '.variable-pricing',
      h(VariablePricing, {
        variablePricing,
      })
    );
  }

  getPrice() {
    const {
      option: { enabled, isModalOption, showDoubleStrikeThroughPrice },
      isTraitsSummary,
      isRefreshLeftAlign,
    } = this.props;

    if (!enabled) {
      return null;
    }

    const showUrgencyPriceLabel =
      !isTraitsSummary && (showDoubleStrikeThroughPrice || isModalOption);

    return h(
      '.price-discount-wrapper',
      !isRefreshLeftAlign && showUrgencyPriceLabel
        ? h(UrgencyPricingLabel, this.props)
        : null,
      h(Price, this.props)
    );
  }

  getValue() {
    const {
      isPaidCloDeal,
      option,
      showXForYStrikethrough,
      isXForYCloDeal,
      isRefreshLeftAlign,
    } = this.props;
    let classes = 'breakout-option-value';
    if (isPaidCloDeal) {
      classes += ' paid-clo-formatted-value';
    }

    return h(
      '.value-source-wrapper',
      h(MSRPLabel, { ...this.props.msrp, isRefreshLeftAlign }),
      h(Value, {
        ...option,
        showXForYStrikethrough,
        isXForYCloDeal,
        classes,
      })
    );
  }

  getValueAndPrice() {
    const {
      option: {
        isPaneOption,
        pricing: { msrpLabel, shippingCharge },
        showDoubleStrikeThroughPrice,
      },
    } = this.props;

    let valueAndPriceClasses = 'pricing-options-wrapper';

    if (showDoubleStrikeThroughPrice) {
      valueAndPriceClasses += '.double-strike';
    }

    if (msrpLabel) {
      valueAndPriceClasses += '.with-msrp';
    }

    const showPrice = this.shouldShowPriceInFirstRow();

    return h(
      `.${valueAndPriceClasses}`,
      this.getValue(),
      h(DoublestrikeRegularPrice, this.props),
      shippingCharge &&
        isPaneOption &&
        h(GoodsShippingLabel, { shippingCharge }),
      showPrice && this.getPrice()
    );
  }

  getDiscount() {
    const showPrice = this.shouldShowPriceInSecondRow();

    return h(
      '.price-discount-message-wrapper',
      showPrice && this.getPrice(),
      h(DiscountBadge, this.props)
    );
  }

  getExpiredOverlay() {
    const { enabled } = this.props.option;

    if (enabled) {
      return null;
    }

    return h('.status-overlay');
  }

  getExpiredOverlayText() {
    const { enabled, text, optionStatus } = this.props.option;
    let classes = 'status-text';

    if (enabled) {
      return null;
    }

    if (optionStatus === 'sold_out') {
      classes = `${classes}.sold-out-color`;
    }

    return h(`.${classes}`, text);
  }

  /* ------------- Start of Refresh Left align specific functions ------------- */

  shouldShowRefreshPriceInFirstRow() {
    return !this.shouldShowRefreshPriceInSecondRow();
  }

  shouldShowRefreshPriceInSecondRow() {
    /**
     * Desktop Only:
     * we should only push the price in second row if it's
     * a deal with an option that has msrp label
     */

    const {
      option: {
        pricing: { msrpLabel },
      },
    } = this.props;

    return msrpLabel;
  }

  getRefreshPriceAndDiscount(showPrice) {
    const {
      isMovieDeal,
      option: { enabled },
    } = this.props;

    if (showPrice) {
      /**
       * Creating this wrapper because of fragments is missing in preact 8.
       * Once we move to preact X, we don't need this kind of wrappers
       * that are supposed to do nothing.
       */
      return h(
        '.price-discount-container',
        !isMovieDeal && enabled && h(PriceLabel, this.props),
        this.getPrice(),
        h(DiscountBadge, this.props)
      );
    }
    return null;
  }

  getRefreshPricingFirstRow() {
    const {
      option: {
        enabled,
        isPaneOption,
        pricing: { msrpLabel, shippingCharge },
        showDoubleStrikeThroughPrice,
      },
    } = this.props;

    let valueAndPriceClasses = 'pricing-options-wrapper';

    if (showDoubleStrikeThroughPrice) {
      valueAndPriceClasses += '.double-strike';
    }

    if (msrpLabel) {
      valueAndPriceClasses += '.with-msrp';
    }

    const showPrice = this.shouldShowRefreshPriceInFirstRow();

    return h(
      `.${valueAndPriceClasses}`,
      showPrice && !enabled && h(PriceLabel, this.props),
      this.getValue(),
      showPrice && h(DoublestrikeRegularPrice, this.props),
      shippingCharge &&
        isPaneOption &&
        h(GoodsShippingLabel, { shippingCharge }),
      this.getRefreshPriceAndDiscount(showPrice)
    );
  }

  getRefreshPricingSecondRow() {
    const {
      option: { enabled },
    } = this.props;

    const showPrice = this.shouldShowRefreshPriceInSecondRow();

    return h(
      '.price-discount-message-wrapper',
      showPrice && !enabled && h(PriceLabel, this.props),
      showPrice && h(DoublestrikeRegularPrice, this.props),
      this.getRefreshPriceAndDiscount(showPrice)
    );
  }

  /* ------------- End of Refresh Left align specific functions ------------- */

  render() {
    const {
      allTraitsSelected,
      isMovieDeal,
      isTraitsSummary,
      memberOnly,
      option: {
        enabled,
        isUrgencyPricing,
        pricing: { showIlsTimeLeft, msrpLabel },
      },
      isRefreshLeftAlign,
    } = this.props;
    let mainClasses = 'breakout-pricing';

    if (!enabled) {
      mainClasses += '.sold-out';
    }

    if (isTraitsSummary) {
      mainClasses += '.has-traits';
    }

    if (showIlsTimeLeft) {
      mainClasses += '.with-price-label';
    }

    if (isUrgencyPricing) {
      mainClasses += '.urgency-pricing-offer';
    }

    if (msrpLabel) {
      mainClasses += '.with-msrp';
    }

    if (memberOnly) {
      return h(`.${mainClasses}`, h('.member-only', memberOnly.title));
    } else {
      let promoIneligibleView;
      if ((!isTraitsSummary || allTraitsSelected) && !isRefreshLeftAlign) {
        promoIneligibleView = getOptionPromoIneligible(this.props.option);
      }
      return h(
        `.${mainClasses}`,
        !isRefreshLeftAlign && !isMovieDeal && h(PriceLabel, this.props),
        !isMovieDeal &&
          (isRefreshLeftAlign
            ? this.getRefreshPricingFirstRow()
            : this.getValueAndPrice()),
        isRefreshLeftAlign
          ? this.getRefreshPricingSecondRow()
          : this.getDiscount(),
        this.getExpiredOverlay(),
        this.getExpiredOverlayText(),
        this.getVariablePricing(),
        promoIneligibleView
      );
    }
  }
}

module.exports = OptionPricing;
